module.exports = __webpack_public_path__ + "static/media/truly_fun.bba266ab.png";